import ServicePanel from "@/api/servicePanel";
import serviceDomain from "@/api/serviceDomain";
import ServiceSubAccs from "@/api/subaccsService";
import { isSiteKind } from "@/components/PlatformCard/subaccountPayload";

const dataOf = (request) => request.then((res) => (res && res.status === 200 && Array.isArray(res.data) ? res.data : [])).catch(() => []);

// The lists the fields of a platform choose from. All of them are loaded, also the ones of fields hidden behind a
// feature flag, so a hidden field keeps its saved value instead of falling back to an empty one.
export async function loadPlatformOptions(kind) {
  const site = isSiteKind(kind);
  const [mailings, pushIntervals, pushDelays, disabledCategories, templates, landings] = await Promise.all([
    dataOf(ServicePanel.getMailingFrequency()),
    dataOf(serviceDomain.getPushIntervals()),
    dataOf(ServicePanel.getPushDelays()),
    site ? dataOf(ServicePanel.getCategories()) : [],
    site ? [] : dataOf(ServicePanel.getUrlTemplates()),
    site ? [] : dataOf(ServiceSubAccs.getLandings()),
  ]);
  return { mailings, pushIntervals, pushDelays, disabledCategories, templates, landings };
}
